import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Product } from '@utils/product';
import { ProductImage } from 'audamatic-ui';
import Image from '../../base_image/component';
import Link from '../../base_link/component';

import './styles/styles.scss';


class BannerLarge extends Component {
  constructor(props) {
    super(props);

    this.product = {};

    if (Array.isArray(props.products)) {
      this.setProduct(props.products[0]);
    }
    this.pushGoogleTags = this.pushGoogleTags.bind(this);
    this.shadowEffect = props['image-shadow'] !== undefined ? props['image-shadow'] : true;
  }

  setProduct(attrs) {
    if (typeof(attrs) === 'object') {
      this.product = new Product(attrs);
    }
  }

  get title() {
    return this.props.title || null;
  }

  get subtitle() {
    return this.props.subtitle || null;
  }

  get text() {
    return this.props.text || null;
  }

  get images() {
    return {
      leftImage: this.props.leftImage || null,
      rightImage: this.props.rightImage || null,
      backgroundImage: this.props.backgroundImage || null,
    };
  }

  get url() {
    return this.props.url || '#';
  }

  get oldPrice() {
    return this.props.oldPrice || '';
  }

  get newPrice() {
    return this.props.newPrice || '';
  }

  get backgroundColor() {
    return this.props.colorCode || '';
  }

  get buttonText() {
    return this.props.buttonText || null;
  }

  get badges() {
    return Array.isArray(this.props.badges) ? this.props.badges : [];
  }


  renderBadge(item, index) {
    return (
      <div className={`banner-s__tag ${item.color === 'red' ? 'banner-s__tag-cta' : ''}`} key={index}>
        <span>{item.textContent}</span>
      </div>
    );
  }


  renderImage() {
    if (this.product.image) {
      return (
        <div className="banner-card-product-image-wrapper">
          <ProductImage product={this.product} />
        </div>
      );
    }
    return (
      <Image src={this.images.leftImage} alt={this.title}/>
    );
  }

  pushGoogleTags() {
    this.props.googleTagMethods()
      .pushPromotionGoogleTag(this.props);
  }

  render() {
    const backgroundStyle = { backgroundColor: this.backgroundColor };
    if (this.images.backgroundImage) {
      backgroundStyle.backgroundImage = `url(${this.images.backgroundImage})`;
    }

    return (
      <Link href={this.url} className="banner banner-card banner-card-large" style={backgroundStyle} onClick={this.pushGoogleTags}>
        <div className="banner-card-media">
          {this.renderImage()}

          {this.badges.map((item, index) => this.renderBadge(item, index))}
        </div>
        <div className="banner-card-body">
          <p className="banner-card-subtitle" dangerouslySetInnerHTML={{ __html: this.subtitle }}></p>
          <h2 className="banner-card-title" dangerouslySetInnerHTML={{ __html: this.title }}></h2>
          {!!this.text &&
            <p className="banner-card-text" dangerouslySetInnerHTML={{ __html: this.text }}></p>
          }

          {!!this.newPrice &&
            <div className="banner-pricing">
              <span className="banner-newprice">{this.newPrice}</span>
              <span className="banner-oldprice">{this.oldPrice}</span>
            </div>
          }
        </div>
        {!!this.buttonText &&
          <span className="banner-btn btn btn-primary tiny hidden-xs">{this.buttonText}</span>
        }
      </Link>
    );
  }
}


BannerLarge.propTypes = {
  /**
   * The title which will be shown in black in the banner
   */
  title: PropTypes.string,
  /**
   * The subtitle which will be shown in green in the banner
   */
  subtitle: PropTypes.string,
  /**
   * Addintional text in smaller black font
   */
  text: PropTypes.string,
  /**
   * The url the banner needs to point to
   */
  url: PropTypes.string,
  /**
   * String that represents the new price in big red font
   */
  newPrice: PropTypes.string,
  /**
   * String that represents the old price with a strikethrough
   */
  oldPrice: PropTypes.string,
  /**
   * Color code for the background
   */
  colorCode: PropTypes.string,
  /**
   * Image place on the left side of the banner
   */
  leftImage: PropTypes.string,
  /**
   * Text that is placed inside the button
   * if there is no text, there will be no button shown
   */
  buttonText: PropTypes.string,
  /**
   * Badges that can be added to the banner
   */
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * String that will be displayed in the badge
       */
      textContent: PropTypes.string,
      /**
       * Color set for the badge. when no color is requested the badge will default to 'red'
       * Options are: 'red' or 'blue'
       */
      color: PropTypes.oneOf(['red', 'blue']),
    })
  ),
  /**
   * Function that returns an object with
   * Google Tags methods
   */
  googleTagMethods: PropTypes.func,
  products: PropTypes.array,
  'image-shadow': PropTypes.string,
  rightImage: PropTypes.string,
  backgroundImage: PropTypes.string,
};


export default BannerLarge;
